import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type { HealthResponse } from "@/api/types";

/**
 * Queries the health endpoint with 30-second polling.
 * Used by the dashboard to display live system dependency status.
 */
export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: () => apiClient<HealthResponse>(ENDPOINTS.health),
    refetchInterval: 30_000,
  });
}
